export const NewWizardSplitTestTemporaryId = 'wizard-split-test';
